import { render, staticRenderFns } from "./platformClassification.vue?vue&type=template&id=370513d0&scoped=true&"
import script from "./platformClassification.vue?vue&type=script&lang=js&"
export * from "./platformClassification.vue?vue&type=script&lang=js&"
import style0 from "./platformClassification.vue?vue&type=style&index=0&id=370513d0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370513d0",
  null
  
)

export default component.exports